<template>
    <div class="ssv-form">
        <div class="input-item">
            <label class="label" for="contactId">Pobočka</label>
            <select class="input input--m" id="contactId" name="contactId" v-model="contactId">
                <option :value="0" disabled>Vyberte</option>
                <option :value="'--other--'">Jiná</option>
                <option v-for="contact in contacts" :value="contact.id">{{contact.city}}, {{contact.street}}</option>
            </select>
            <ssv-order-error-field field="distributor.contactId"/>
        </div>
        <span v-if="contactId === '--other--'">Vyplňte prosím adresu své pobočky do poznámky této objednávky</span>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';
import SsvOrderErrorField from '../error/ErrorField';
import {contactByIdentificationNumber} from '../api/contact';

export default {
    name:       'SsvOrderDistributorForm',
    components: {
        SsvOrderErrorField
    },
    computed:   {
        ...mapFields('ssvOrder', [
            'additionalData.contactId',
            'billingInformation.identificationNumber',
        ]),
    },
    watch:      {
        identificationNumber: function () {
            this.fetchContacts();
        }
    },
    data() {
        return {
            contacts: [],
        }
    },
    methods: {
        ...mapActions('ssvOrder', ['setError']),
        validate() {
            if (!this.contactId) this.setError({
                msg: 'Vyberte pobočku',
                key: 'distributor.contactId'
            });
        },
        fetchContacts() {
            contactByIdentificationNumber(this.identificationNumber)
            .then((data) => this.contacts = data);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/distributor/DistributorForm.vue